package com.advaita.cloud.drive.ui.components

import androidx.compose.runtime.Composable
import com.advaita.cloud.drive.ui.store.FileBrowserStore
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

enum class ToastLevel { ERROR, INFO, SUCCESS }

data class ToastItem(
    val id: Long,
    val message: String,
    val level: ToastLevel,
)

@Composable
fun ToastStack(store: FileBrowserStore) {
    if (store.toasts.isEmpty()) return
    Div(attrs = { classes("toast-stack") }) {
        for (toast in store.toasts) {
            Div(attrs = {
                val levelClass = when (toast.level) {
                    ToastLevel.ERROR -> "error"
                    ToastLevel.SUCCESS -> "success"
                    ToastLevel.INFO -> "info"
                }
                classes("toast", levelClass)
                attr("data-toast-id", toast.id.toString())
                onClick { store.dismissToast(toast.id) }
            }) {
                Text(toast.message)
            }
        }
    }
}
